export default "__VITE_ASSET__Dl$WLL4w__"